import React from 'react';
import * as styles from './IconPrefix.module.css';

export type IconType = 'prefecture' | 'content' | 'method' | 'specialist' | 'web' | 'search' | 'check' | 'time' | 'smartphone' | 'place' | 'people' | 'textSnippet' | 'category';
export type IconColor = 'default' | 'accent' | 'gray';
export type IconSize = 'default' | 'small' | 'large';

/**
 * アイコン付きテキストのコンポーネント。
 * アイコンとテキストを組み合わせて表示する。
 * 
 * @param {Object} props - コンポーネントのプロパティ
 * @param {React.ReactNode} props.children - テキストコンテンツ
 * @param {IconType} props.icon - アイコンの種類 
 * @param {IconColor} props.color - アイコンの色
 * @param {IconSize} props.size - アイコンのサイズ
 * @param {string} props.className - 追加のクラス名
 * @param {keyof JSX.IntrinsicElements} props.as - 使用するHTML要素のタイプ
 * @returns {JSX.Element} アイコン付きテキストのコンポーネント
 */
interface IconPrefixProps {
  children: React.ReactNode;
  icon: IconType;
  color?: IconColor;
  size?: IconSize;
  className?: string;
  as: keyof JSX.IntrinsicElements;
}

/**
 * アイコン付きテキストのコンポーネント。
 * アイコンとテキストを組み合わせて表示する。
 * 
 * @param {Object} props - コンポーネントのプロパティ
 * @param {React.ReactNode} props.children - テキストコンテンツ
 * @param {IconType} props.icon - アイコンの種類 
 * @param {IconColor} props.color - アイコンの色
 * @param {IconSize} props.size - アイコンのサイズ
 * @param {string} props.className - 追加のクラス名
 * @param {keyof JSX.IntrinsicElements} props.as - 使用するHTML要素のタイプ
 * @returns {JSX.Element} アイコン付きテキストのコンポーネント
 */
export const IconPrefix: React.FC<IconPrefixProps> = ({
  children,
  icon,
  color = 'default',
  size = 'default',
  className = '',
  as: Component,
}) => {
  const getIconClass = () => {
    const baseClass = styles.iconPrefix;
    const iconClass = styles[`icon${icon.charAt(0).toUpperCase() + icon.slice(1)}`];
    const colorClass = color !== 'default' ? styles[`iconColor${color.charAt(0).toUpperCase() + color.slice(1)}`] : '';
    const sizeClass = size !== 'default' ? styles[`iconSize${size.charAt(0).toUpperCase() + size.slice(1)}`] : '';
    
    return [baseClass, iconClass, colorClass, sizeClass, className]
      .filter(Boolean)
      .join(' ');
  };

  return (
    <Component className={getIconClass()}>
      {children}
    </Component>
  );
}; 